import { ViewChild, Component, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
// import {MatProgressBar, MatList} from '@angular/material';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { FileDialogService } from '../services/file-dialog.service';
// import { FlexLayoutModule } from '@angular/flex-layout';
// import {HttpClient, HttpHeaders} from '@angular/common/http';
import Api from '../../common/services/api.service';




@Component({
  selector: 'app-file-dialog',
  templateUrl: './file-dialog.component.html',
  styleUrls: ['./file-dialog.component.css']
})


export class FileDialogComponent implements OnInit {

  @ViewChild('file') file;
  public files: Set<File> = new Set();
  serviceUrl = "getState";

  progress;
  canBeClosed = true; 
  primaryButtonText = 'Valider';
  showCancelButton = true; 
  uploading = false;
  uploadSuccessful = false;
  showShooseLabel = true;
  uploadProgress = true;

  progressCompleted = false;


  constructor(public dialogRef: MatDialogRef<FileDialogComponent>, public fileDialogService: FileDialogService, private api: Api) { }

 
  ngOnInit() {}

  addFiles() { this.file.nativeElement.click();}

  onCloseDialog(): void {this.dialogRef.close();}

  onFilesAdded() {
	  const files: { [key: string]: File } = this.file.nativeElement.files;
	  for (let key in files) {
	    if (!isNaN(parseInt(key))) {
	      this.files.add(files[key]);
	    }
	  }
    if (this.files != null){
      this.showShooseLabel = false;
    }

  }

  cancelImport() {
 	this.dialogRef.close();
 }

 closeDialog() {
 
  if (this.uploadSuccessful) {
    return this.dialogRef.close();
  }

  this.uploading = true;

  this.progress = this.fileDialogService.upload(this.files);

  let allProgressObservables = [];
  for (let key in this.progress) {
    allProgressObservables.push(this.progress[key].progress);
    ///console.log("heho: ", this.progress[key].progress);

  }
 /// console.log("Haaaaaaa");
  this.uploadProgress = false;

  this.primaryButtonText = 'Terminer';

  this.canBeClosed = false;
  this.dialogRef.disableClose = true;

  this.showCancelButton = false;
  
  ///console.log("Hooooooooooooooooooo");
  forkJoin(allProgressObservables).subscribe(end => {
   /// console.log("Huuuuuuuuuuuuuuuuuuuuuuuuuu");
    this.canBeClosed = true;
    this.dialogRef.disableClose = false;

    this.uploadSuccessful = true;


    console.log("Upload Statut: ", this.uploadSuccessful)
 
    if (this.uploadSuccessful){
      console.log("FileDeal");
 
      this.api.get(this.serviceUrl).subscribe((val)=>{
            console.log("Valeur: ", val);
            if (val == true){
              ///console.log(" DONE Valeur: ", val);
            }
            else{
              ///console.log("ERROR Valeur: ", val);
            }
          
          });
    }
  });

  ///console.log("Hiiiiiiiiiiiiiiiiiiiiiii");
/*
  if (this.uploadSuccessful == true){
    console.log("H22222222222222222222");

     this.api.get(this.serviceUrl).subscribe((val)=>{
       console.log("Valeur: ", val);
     });

     console.log("Haaaaaaa");
  }
*/

 }

}



// WEBPACK FOOTER //
// ./src/app/admin-app/file-dialog/file-dialog.component.ts